export default "c973cf8fb77d3294.png"